import React from 'react'
import PropTypes from 'prop-types'

/**
 * Debug panel for testing timeout functionality
 * Only shown in development or when debug mode is enabled
 */
const TimeoutDebugPanel = ({
    onTriggerWarning,
    onTriggerTimeout,
    remainingTime,
    isWarning,
    isIdle,
    isVisible = false,
    onClose,
}) => {
    if (!isVisible) {
        return null
    }

    const panelStyles = {
        position: 'fixed',
        top: '10px',
        right: '10px',
        backgroundColor: '#f8f9fa',
        border: '2px solid #007bff',
        borderRadius: '8px',
        padding: '12px',
        zIndex: 9998,
        fontSize: '12px',
        fontFamily: 'monospace',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        minWidth: '200px',
    }

    const buttonStyles = {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '4px 8px',
        margin: '2px',
        cursor: 'pointer',
        fontSize: '11px',
    }

    const statusStyles = {
        marginBottom: '8px',
        padding: '4px',
        borderRadius: '4px',
        backgroundColor: isIdle ? '#dc3545' : isWarning ? '#ffc107' : '#28a745',
        color: isIdle || isWarning ? '#000' : '#fff',
    }

    const formatTime = ms => {
        const minutes = Math.floor(ms / 60000)
        const seconds = Math.floor((ms % 60000) / 1000)
        return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }

    return (
        <div style={panelStyles}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <div style={{ fontWeight: 'bold', color: '#007bff' }}>HPP SDK Debugger</div>
                <button
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '16px',
                        cursor: 'pointer',
                        color: '#666',
                        padding: '0',
                        lineHeight: '1',
                    }}
                    onClick={onClose}
                    title="Close debug panel"
                >
                    ✕
                </button>
            </div>

            <div style={statusStyles}>Status: {isIdle ? 'TIMED OUT' : isWarning ? 'WARNING' : 'ACTIVE'}</div>

            <div style={{ marginBottom: '8px' }}>Remaining: {formatTime(remainingTime)}</div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <button style={buttonStyles} onClick={onTriggerWarning} disabled={isWarning || isIdle}>
                    Trigger Warning
                </button>

                <button style={buttonStyles} onClick={onTriggerTimeout} disabled={isIdle}>
                    Trigger Timeout
                </button>
            </div>
        </div>
    )
}

TimeoutDebugPanel.propTypes = {
    onTriggerWarning: PropTypes.func.isRequired,
    onTriggerTimeout: PropTypes.func.isRequired,
    remainingTime: PropTypes.number.isRequired,
    isWarning: PropTypes.bool.isRequired,
    isIdle: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
}

export default TimeoutDebugPanel
